"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const react_router_1 = require("react-router");
const uiConstants_1 = require("../../../../constants/uiConstants");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const styledAppBar_1 = require("../common/styledAppBar");
const lexico = new lexico_1.default();
const shouldShowLoginButton = (path) => {
    const pathsToCheck = ['/message', '/register', '/password/forgot', '/signin/activate', '/signin/reactivate'];
    return pathsToCheck.some(subPath => path.includes(subPath));
};
const hsbcLogoAsset = (theme) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { style: {
                    width: '1px',
                    height: '30px',
                    background: 'black',
                    marginLeft: theme.tsGoUnit.tsUnitOneAndHalf,
                } }), (0, jsx_runtime_1.jsxs)("p", { style: {
                    fontSize: theme.typography.tsFontSize.default,
                    fontWeight: theme.typography.tsFontWeight.default,
                    lineHeight: theme.tsGoUnit.tsUnitTriple,
                    color: 'black',
                    margin: '0 0 0 30px',
                    position: 'relative',
                }, children: [' ', "Business Virtual Cards"] })] }));
};
const AuthForm = ({ children }) => {
    const location = (0, react_router_1.useLocation)();
    const theme = (0, material_1.useTheme)();
    const navigate = (0, react_router_1.useNavigate)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Paper, { style: {
            gap: '25px',
            flexDirection: 'column',
            backgroundColor: 'initial',
            height: '100dvh',
            paddingBottom: theme.tsGoUnit.tsUnit,
            overflow: 'auto',
            display: 'flex',
        }, children: [(0, jsx_runtime_1.jsxs)(styledAppBar_1.StyledAppBar, { position: "sticky", children: [globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? hsbcLogoAsset(theme) : null, shouldShowLoginButton(location.pathname) ? ((0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "login-btn", label: lexico.trc('Button', 'Login'), onClick: () => {
                            void navigate('/signin/login');
                        }, disabled: false, color: uiConstants_1.UI_BUTTON_SECONDARY })) : null] }), children] }));
};
exports.default = AuthForm;
